import styled from 'styled-components';

interface InfoBoxProps {
  isActive?: boolean
}

export const Container = styled.div<InfoBoxProps>`
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;

  overflow: none;
  margin-bottom: 10px;
  padding: 15px 0;

  border-radius:4px;
  background-color: #FFF;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);
  border: 2px solid ${props => props.isActive ? props.theme.colors.mainColor : '#FFF'};

  transition: .2s all ease-in-out;

  > svg {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 70px;
    height: 70px;
    padding: 25px;
    color: ${props => props.isActive ? props.theme.colors.mainColor : '#B2BDB9'};
    cursor: pointer;
    transition: .2s all ease-in-out;

    &:hover {
      transform: scale(1.3);
      color: ${props => props.isActive ? props.theme.colors.mainColor : '#869891'};

    }
  }
`;
